export const forBusiness_email_choose = [
	{
		icon: '⏳',
		title: 'chooseData_title1',
		subtitle: 'chooseData_subtitle1',
	},
	{
		icon: '⭐️',
		title: 'chooseData_title2',
		subtitle: 'chooseData_subtitle2',
	},
	{
		icon: '🌈',
		title: 'chooseData_title3',
		subtitle: 'chooseData_subtitle3',
	},
	{
		icon: '🚀',
		title: 'chooseData_title4',
		subtitle: 'chooseData_subtitle4',
	},
	{
		icon: '✌️',
		title: 'chooseData_title5',
		subtitle: 'chooseData_subtitle5',
	},
];
